import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { loadBrand } from '../redux/actions/brandActions';
import { brandCss } from '../lib/brandColors';

/**
 * Puts the school's accent colour on the page, and fetches the brand once
 * on load. Renders a style sheet of custom properties, or nothing for a
 * school with no brand.
 */
function BrandStyle({ accentColor, load }) {
  useEffect(() => {
    load();
  }, [load]);

  const css = brandCss(accentColor);
  return css ? <style data-brand>{css}</style> : null;
}

BrandStyle.propTypes = {
  accentColor: PropTypes.string,
  load: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  accentColor: state.brand?.accentColor ?? null
});

const mapDispatchToProps = (dispatch) => ({
  load: () => loadBrand(dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(BrandStyle);
